import { formatPrice } from '@lib/utils/units';
import { Price } from '@stores/Billing';
import classNames from 'classnames';
import React from 'react';
import css from './PriceDisplay.module.scss';

interface PriceDisplayProps {
  price: Price;
  className?: string;
  textAfterPrice?: string;
}

export const PriceDisplay: React.FC<PriceDisplayProps> = ({ price, className, textAfterPrice }) => {
  const formattedPrice = formatPrice(price);
  return (
    <div className={classNames(css.priceDisplay, className)}>
      <span className={css.priceCurrency}>{formattedPrice}</span>
      {textAfterPrice && <span className={css.priceInterval}>{textAfterPrice}</span>}
    </div>
  );
};
